import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { SUBMOTIVE2, SUBMOTIVE2_DETAIL } from '../../../../../routes/paths';
import {
    asyncGetParamWithNestedParent,
    asyncGetSubmotive2Historical,
    asyncPatchSubmotive2Param,
    asyncPostSubmotive2Param,
} from '../../../../../services/param.service';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { Param, ParamHistorical } from '../../../../../shared/types/param';

export const useSubmotive2Form = () => {
    const navigate = useNavigate();
    const { idSubmotive2 } = useParams();
    const [submotive2, setSubmotive2] = useState<Param>();
    const [loading, setLoading] = useState(false);
    const [formikSubmotive2Data, setFormikSubmotive2Data] =
        useState<FormikProps<Param>>();
    const [showHistorical, setShowHistorical] = useState(false);
    const [submotive2Historical, setSuptypeDPHistorical] =
        useState<ParamHistorical[]>();

    const isValidForm = formikSubmotive2Data?.isValid;

    const handleCleanAndBack = () => {
        formikSubmotive2Data?.resetForm();
        navigate(SUBMOTIVE2);
    };

    const handleSubmit = async () => {
        await formikSubmotive2Data?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Param = formikSubmotive2Data?.values;

        let res: any | undefined = undefined;

        try {
            if (submotive2 && submotive2.id)
                res = await asyncPatchSubmotive2Param(submotive2.id, data);
            else res = await asyncPostSubmotive2Param(data);
        } catch (error) {}
        if (res?.items) {
            const item = Array.isArray(res?.items) ? res?.items[0] : res?.items;
            ToastSwal.fire({
                text: `¡Felicidades! el submotivo 2 se ${
                    submotive2 && submotive2.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${SUBMOTIVE2_DETAIL}/${item.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    submotive2 && submotive2.id ? 'actualizar' : 'crear'
                } el submotivo 2. Por favor, asegúrate de ${
                    submotive2 && submotive2.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idSubmotive2)) {
            setLoading(true);
            asyncGetParamWithNestedParent(idSubmotive2, 3)
                .then((submotive2: any) => {
                    if (!submotive2 || !submotive2.items) navigate(SUBMOTIVE2);
                    setSubmotive2(submotive2?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idSubmotive2]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetSubmotive2Historical(idSubmotive2)
                .then((resp) => {
                    if (resp) setSuptypeDPHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        submotive2,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikSubmotive2Data,
        submotive2Historical,
        showHistorical,
        setShowHistorical,
    };
};
